<template>
    <div>
        <el-table :data="shopDeviceTransAuditRecList" border style="width: 100%">
            <el-table-column prop="retailerComName" label="机构名称" align="left"></el-table-column>
            <el-table-column prop="auditorName" label="审核人" width="120" align="left"></el-table-column>
            <el-table-column prop="auditTime" label="审核时间" width="160" align="center"></el-table-column>
            <el-table-column prop="auditState" label="审核状态" width="100" align="center">
                <template slot-scope="rows">
                    <span class="font-red" v-if="rows.row.auditState === 0">未审核</span>
                    <span class="font-green" v-if="rows.row.auditState === 1">已通过</span>
                    <span class="font-red" v-if="rows.row.auditState === -1">未通过</span>
                </template>
            </el-table-column>
            <el-table-column prop="auditDesc" label="审核描述" width="160" align="left"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import assetVchrApi from '../../api/assetVchr'

    export default {
        name: 'swb-shop-device-trans-audit-rec-list',
        desc: '设备调拨单审核记录列表',
        props: {
            voucherId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                shopDeviceTransAuditRecList: []
            }
        },
        created: function () {
            this.getShopDeviceTransAuditRecsByVoucherId();
        },
        methods: {
            getShopDeviceTransAuditRecsByVoucherId: function () {
                let self = this;
                let postData = {
                    voucherId: self.voucherId
                };
                //
                let theLoad = MsgBox.loading();
                assetVchrApi.getShopDeviceTransAuditRecByVoucherId(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        self.shopDeviceTransAuditRecList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/transVoucher/ShopDeviceTransAuditResList.vue